export default __webpack_public_path__ + "static/media/pause.cf4fa392.svg";